function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS, LLOYDS2023 } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.465 13.074h-5.488V6.257c0-.56.465-1.027 1.023-1.027.558 0 1.023.466 1.023 1.027v4.762h3.442c.558 0 1.023.467 1.023 1.028 0 .56-.465 1.027-1.023 1.027M12 0C5.395 0 0 5.416 0 12.047 0 18.677 5.395 24 12 24s12-5.323 12-11.953C24 5.417 18.605 0 12 0m0 21.292c-5.116 0-9.21-4.11-9.21-9.245 0-5.136 4.094-9.245 9.21-9.245 5.116 0 9.21 4.109 9.21 9.245 0 5.136-4.094 9.245-9.21 9.245",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0752116,1 23,5.92478842 23,12 C23,18.0752116 18.0752116,23 12,23 C5.92478842,23 1,18.0752116 1,12 C1,5.92478842 5.92478842,1 12,1 Z M12,3 C7.02935792,3 3,7.02935792 3,12 C3,16.9706421 7.02935792,21 12,21 C16.9706421,21 21,16.9706421 21,12 C21,7.02935792 16.9706421,3 12,3 Z M13.0819634,6 L13.0819634,13.0808802 L8.70710678,17.4557369 L7.29289322,16.0415233 L11.081,12.252 L11.0819634,6 L13.0819634,6 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.465 13.074h-5.488V6.257c0-.56.465-1.027 1.023-1.027.558 0 1.023.466 1.023 1.027v4.762h3.442c.558 0 1.023.467 1.023 1.028 0 .56-.465 1.027-1.023 1.027M12 0C5.395 0 0 5.416 0 12.047 0 18.677 5.395 24 12 24s12-5.323 12-11.953C24 5.417 18.605 0 12 0m0 21.292c-5.116 0-9.21-4.11-9.21-9.245 0-5.136 4.094-9.245 9.21-9.245 5.116 0 9.21 4.109 9.21 9.245 0 5.136-4.094 9.245-9.21 9.245",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.92 1 12C1 18.08 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM12 21.7C6.65 21.7 2.3 17.35 2.3 12C2.3 6.65 6.65 2.29999 12 2.29999C17.35 2.29999 21.7 6.65 21.7 12C21.7 17.35 17.35 21.7 12 21.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 14.53L16.81 17.73L17.73 16.81L14.53 13.61C14.29 13.98 13.98 14.29 13.61 14.53Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 10.65V3.83002H11.35V10.65C10.85 10.89 10.5 11.4 10.5 12C10.5 12.83 11.17 13.5 12 13.5C12.83 13.5 13.5 12.83 13.5 12C13.5 11.41 13.15 10.9 12.65 10.65Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
export default function (_ref) {
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var svg;
  switch (brand) {
    case LLOYDS:
      svg = LloydsIcon;
      break;
    case BOS:
      svg = BosIcon;
      break;
    case BIRMINGHAM_MIDSHIRES:
    case HALIFAX:
      svg = HalifaxIcon;
      break;
    case LLOYDS2023:
      svg = Lloyds2023Icon;
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn("Icon is not available in brand \"".concat(brand, "\"."));
      svg = function svg() {
        return null;
      };
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}